import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmxWebComponentsModule } from "@cmx-web-components/angular";
import { AlertComponent } from "./alert.component";
import { AlertService } from "./alert.service";

@NgModule({
  imports: [CommonModule, CmxWebComponentsModule],
  providers: [AlertService],
  declarations: [AlertComponent],
  exports: [AlertComponent],
  entryComponents: [AlertComponent],
})
export class AlertModule {
  static forRoot(): ModuleWithProviders<AlertModule> {
    return {
      ngModule: AlertModule,
    };
  }
}
